export default __webpack_public_path__ + "static/media/Bairi Gold Logo.e79b546d.png";